import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ModalResponsavelComponent } from 'src/app/modules/projeto-completo/modal-responsavel/modal-responsavel.component';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';
import { ProjetoAgregadorService } from 'src/app/modules/projeto-completo/services/projeto-agregador.service';

@Component({
  selector: 'app-agregador-lista-view',
  templateUrl: './agregador-lista-view.component.html',
  styleUrls: ['./agregador-lista-view.component.scss']
})
export class AgregadorListaViewComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: any;
  listaProjeto: any = [];
  pathRoute: string;

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    private myService: ProjetoAgregadorService,
    private activatedRoute: ActivatedRoute,
  ) {
    super()
  }

  ngOnInit(): void {
    this.loading();
    this.idProjeto = this.activatedRoute.snapshot.parent.params.idProjeto;
    this.addSub(
      this.myService.getList(this.idProjeto, true).subscribe((res) => {
        this.listaProjeto = res;
        this.loaded();
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  view(data) {
    return ["/projetos/projeto/" + data.id + "/cadastro"];
  }

  viewResonsavel(projeto: ProjetoCadastro) {
    this.modalResonsavel.openModal([projeto, ...projeto?.resp_adj]);
  }
  
  hasTag(projeto, id: number,key:string){
    if(projeto[key]){
      var ids = projeto[key].split(",");
      if(projeto[key + '_pg_id']){
        ids += projeto[key + '_pg_id'].split(",");
      }
      return ids.includes(id.toString());
    }
  }
}
